module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAOBAMAAAC88gOBAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAAd0SU1FB9kKFhU5K37y4sQAAAAZdEVYdENvbW1lbnQAQ3JlYXRlZCB3aXRoIEdJTVBXgQ4XAAAAFVBMVEX4gHhwWEiAeHCoqHjY2MD4+Pj///+GXai7AAAAAXRSTlMAQObYZgAAAAFiS0dEBmFmuH0AAABsSURBVAjXZc7BCQJhDEThCBag2EHCFOAf5y5oBQ/SfytedpHV75Z3GBLn98EzXn3wiP4RLoynaIyrw4CUjEDaglXMgFUdHrCmYA8CS0Ux8w0FvW8kYgvWEKty5arMzlyZ+f/Y7Xjf43Q9uHwAUhAughDr/YkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/types/Normal.png
// module id = 169
// module chunks = 0